var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1834 8.0749C29.1834 7.79157 29.0418 7.6499 28.9001 7.50824L17.4251 0.849902C17.2834 0.708236 17.0001 0.708236 16.7168 0.849902L5.10011 7.50824C4.95844 7.6499 4.81677 7.79157 4.81677 8.0749C4.81677 8.35824 4.95844 8.4999 5.10011 8.64157L16.5751 15.2999C16.7168 15.2999 16.8584 15.4416 16.8584 15.4416C16.8584 15.4416 17.1418 15.4416 17.1418 15.2999L28.6168 8.64157C29.0418 8.4999 29.1834 8.21657 29.1834 8.0749Z",
    fill: "#52C88A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0167 18.6999L3.54172 12.0416C3.25838 11.8999 2.97505 11.8999 2.83338 12.0416C2.69172 12.1832 2.55005 12.4666 2.55005 12.6082V25.9249C2.55005 26.2082 2.69172 26.3499 2.83338 26.4915L14.3084 33.1499C14.45 33.1499 14.5917 33.2915 14.5917 33.2915C14.5917 33.2915 14.875 33.2915 14.875 33.1499C15.0167 33.0082 15.1584 32.8665 15.1584 32.5832V19.2666C15.4417 18.9832 15.3 18.8416 15.0167 18.6999Z",
    fill: "#52C88A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 12.0416C31.0251 11.8999 30.7417 11.8999 30.4584 12.0416L18.9834 18.6999C18.8417 18.8416 18.7001 18.9832 18.7001 19.2666V32.5832C18.7001 32.8665 18.8417 33.0082 18.9834 33.1499C19.1251 33.1499 19.2667 33.2915 19.2667 33.2915C19.2667 33.2915 19.5501 33.2915 19.5501 33.1499L31.0251 26.4915C31.1667 26.3499 31.3084 26.2082 31.3084 25.9249V12.6082C31.4501 12.4666 31.3084 12.1832 31.1667 12.0416Z",
    fill: "#52C88A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/box-icon.4a6a46a2f2c9f32b64868427fbb39f7d.svg";
export { ForwardRef as ReactComponent };